import React from 'react';
import { MessageModal } from 'src/common/components/interactive-dialogue/components/interactive-dialog-content/interactive-dialog-content';
import {
  popEmeraldModal,
  pushEmeraldModal,
} from 'src/common/emerald-modal-manager/emerald-modal-manager';
import { EmeraldDialogTypes } from 'src/common/enumerations/emerald-dialog-types';
import { IMessageModal } from 'src/common/interfaces/dtos/IMessageModal';
import { FailedToPrintReceipt, NoPrinterConnection } from 'src/common/helpers/error-code';

export const showBalanceInquiryModal = (modalProps: IBalanceInquiryModalProps): void => {
  pushEmeraldModal(
    <BalanceInquiryModal
      success={modalProps.success}
      showBalance={modalProps.showBalance}
      remainingBalance={modalProps.remainingBalance}
      wrongType={modalProps.wrongType}
      errorCode={modalProps.errorCode}
    />,
  );
};

const BalanceInquiryModal: React.FC<IBalanceInquiryModalProps> = ({
  success,
  showBalance,
  remainingBalance,
  wrongType,
  errorCode,
}): JSX.Element => {
  let message: IMessageModal;

  if (success && !showBalance) {
    message = {
      message: 'BalanceInquiryModal_MessageSuccess',
      subMessage: 'BalanceInquiryModal_SubmessageSuccess',
      hideCancelButton: true,
      type: EmeraldDialogTypes.Success,
      onAccept: () => popEmeraldModal(),
      acceptButtonLabel: 'Ok',
    };
  } else if (success && showBalance) {
    message = {
      title: 'OnlineItem',
      message: `$${remainingBalance?.toFixed(2)}`,
      subMessage: 'EPS_BalanceInquery_RemainingBalance',
      hideCancelButton: true,
      type: EmeraldDialogTypes.Info,
      onAccept: () => popEmeraldModal(),
      acceptButtonLabel: 'Ok',
    };
  } else if (wrongType) {
    message = {
      title: 'OnlineItem',
      message: 'EPS_BalanceInquery_BalanceText',
      subMessage: 'EPS_BalanceInquiry_NotAllowed',
      hideCancelButton: true,
      type: EmeraldDialogTypes.Error,
      onAccept: () => popEmeraldModal(),
      acceptButtonLabel: 'Ok',
    };
  } else if (errorCode === NoPrinterConnection) {
    message = {
      message: 'EPS_BalanceInquery_BalanceText',
      subMessage: 'EPS_BalanceInquiry_NoPrinterConnection',
      hideCancelButton: true,
      type: EmeraldDialogTypes.Status,
      onAccept: () => popEmeraldModal(),
      acceptButtonLabel: 'Ok',
    };
  } else if (errorCode === FailedToPrintReceipt) {
    message = {
      message: 'EPS_BalanceInquiry_FailedToPrintReceipt',
      subMessage: `EPS_BalanceInquery_RemainingBalanceWithBalance`,
      subMessageArgs: { arg: remainingBalance ? remainingBalance?.toFixed(2) : '' },
      hideCancelButton: true,
      type: EmeraldDialogTypes.Status,
      onAccept: () => popEmeraldModal(),
      acceptButtonLabel: 'Ok',
    };
  } else {
    message = {
      message: 'EPS_BalanceInquery_BalanceText',
      subMessage: 'EPS_BalanceInquiry_TransactionDeclined',
      hideCancelButton: true,
      type: EmeraldDialogTypes.Status,
      onAccept: () => popEmeraldModal(),
      acceptButtonLabel: 'Ok',
    };
  }
  return <MessageModal {...message} />;
};

export interface IBalanceInquiryModalProps {
  success: boolean;
  showBalance: boolean;
  remainingBalance?: number;
  wrongType?: boolean;
  errorCode?: string;
}

export default BalanceInquiryModal;
